import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M10 12H6V8H4v12h16V8H10z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 6H10v2h10v12H4V8h2v4h2V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
})), 'MarkunreadMailboxTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MarkunreadMailboxTwoTone.js
// module id = 4781
// module chunks = 2